import { publicApi } from "@/lib/axios/instances";
import { ApiMetaParams, ApiResponse } from "@/types/api";
import { Lookbook, LookbookOutfit } from "@/types/lookbook";

export const lookbooksService = {
  getAll: async (
    params: ApiMetaParams = {},
    config: Parameters<typeof publicApi.get>[1] = {}
  ): Promise<ApiResponse<Lookbook[]>> => {
    const { data } = await publicApi.get("/lookbooks", { params, ...config });
    return data;
  },

  getById: async (
    id: number,
    config: Parameters<typeof publicApi.get>[1] = {}
  ): Promise<Lookbook> => {
    const { data } = await publicApi.get(`/lookbooks/${id}`, { ...config });
    return data;
  },

  getOutfits: async (
    id: number,
    config: Parameters<typeof publicApi.get>[1] = {}
  ): Promise<LookbookOutfit[]> => {
    const { data } = await publicApi.get(`/lookbooks/${id}/outfits`, { ...config });
    return data;
  },

  getOutfit: async (
    id: number,
    outfitId: number,
    config: Parameters<typeof publicApi.get>[1] = {}
  ): Promise<LookbookOutfit> => {
    const { data } = await publicApi.get(`/lookbooks/${id}/outfits/${outfitId}`, { ...config });
    return data;
  },
};
